import React from 'react';
import { UrgencyBanner } from './components/UrgencyBanner';
import { Hero } from './components/Hero';
import { InitialTestimonials, MoreTestimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { PackContents, MethodOverview } from './components/MethodOverview';
import { FAQ } from './components/FAQ';
import { CostComparison } from './components/CostComparison';
import { Guarantee, Footer } from './components/Footer';
import { FloatingNotification } from './components/FloatingNotification';
import { EmotionalClose } from './components/EmotionalClose';
import { MetaPixel } from './components/MetaPixel';
const TransitionPhrase = () => <div className="max-w-3xl mx-auto px-6 py-8 text-center" data-id="element-0" data-mp="2wk9y4kb1ymz3">
    <div className="gold-rule mb-4" aria-hidden="true" data-id="element-1" data-mp="2whx9joashed2">
      <span className="text-brand-gold text-xs" data-id="element-2" data-mp="28tmi1bqzgr1g">◆</span>
    </div>
    <p className="text-xl md:text-3xl font-display italic text-brand-purpleDark/85 leading-relaxed" data-id="element-3" data-mp="23vchelmhoy8g">
      La próxima sesión puede ser diferente.
    </p>
  </div>;
export function App() {
  return <div className="min-h-screen w-full text-brand-text font-sans selection:bg-brand-gold/25 selection:text-brand-purpleDark" data-id="element-4" data-mp="3mlj98vzqhf3l">
      <MetaPixel data-id="element-5" data-mp="3rbzo8kj7d8s2" />
      <UrgencyBanner data-id="element-6" data-mp="3rdkg22e4udm8" />
      <main data-id="element-7" data-mp="3rd17vdeab3le">
        <Hero data-id="element-8" data-mp="3relvej26lm9r" />
        <PackContents data-id="element-9" data-mp="5ot150vj28n" />
        <InitialTestimonials data-id="element-10" data-mp="6801qozk67w" />
        <PainPoints data-id="element-11" data-mp="5gbv0xpxarn" />
        <MethodOverview data-id="element-12" data-mp="7sulgbavp5r" />
        <MoreTestimonials data-id="element-13" data-mp="2zld4hgdhhrep" />
        <Guarantee data-id="element-14" data-mp="2zm4xqkjlzd1t" />
        <FAQ data-id="element-15" data-mp="2zmo89g6xiz5t" />
        <CostComparison data-id="element-16" data-mp="2zn6bwxvx8fnr" />
        <TransitionPhrase data-id="element-17" data-mp="33mf25srr5vek" />
        <EmotionalClose data-id="element-18" data-mp="33nq5xsl7735o" />
      </main>
      <Footer data-id="element-19" data-mp="33ori60dy9voz" />
      <FloatingNotification data-id="element-20" data-mp="33oi152avuyvf" />
    </div>;
}